import {
  Alert,
  BasicInput,
  Button,
  Col,
  Loading,
  Row,
  SectionTitle,
  Yup,
  useShowNotification
} from '@elotech/components';
import { Formik } from 'formik';
import { UserService } from 'itbi-common/service';
import React, { useState } from 'react';

type Props = {
  userId: string;
};

type ResetPasswordValue = {
  newPassword: string;
  confirmNewPassword: string;
};

const initialValue: ResetPasswordValue = {
  newPassword: '',
  confirmNewPassword: ''
};

const validationSchema = Yup.object().shape({
  newPassword: Yup.string()
    .label('Nova senha')
    .required(),
  confirmNewPassword: Yup.string()
    .label('Confirmação')
    .required()
    .oneOf([Yup.ref('newPassword')], 'As senhas devem ser iguais.')
});

const ResetPassword = ({ userId }: Props) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const showNotification = useShowNotification();

  const toggleOpen = () => setOpen(value => !value);

  const onSubmit = (value: ResetPasswordValue) => {
    setLoading(true);

    UserService.changePassword(userId, {
      temporaryPassword: false,
      password: value.newPassword
    })
      .then(() => {
        showNotification({
          level: 'success',
          title: 'Senha alterada com sucesso'
        });
        toggleOpen();
      })
      .catch(error => {
        setLoading(false);

        Alert.error(
          {
            title: 'Erro ao alterar a senha do usuário'
          },
          error
        );
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <SectionTitle>Privacidade e Segurança</SectionTitle>
      {open ? (
        <>
          <Loading loading={loading} />
          <Formik
            initialValues={initialValue}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
          >
            {formProps => (
              <Row>
                <BasicInput
                  name="newPassword"
                  label="Nova Senha"
                  type="password"
                  size={3}
                />
                <BasicInput
                  name="confirmNewPassword"
                  label="Confirme a Senha"
                  type="password"
                  size={3}
                />
                <Col md={6} className="form-group">
                  <label className="label" />
                  <Button
                    className="inline"
                    iconPosition="left"
                    onClick={formProps.submitForm}
                    type="submit"
                  >
                    Confirmar
                  </Button>
                  <Button
                    className="inline"
                    iconPosition="left"
                    onClick={toggleOpen}
                    color="neutral"
                  >
                    Cancelar
                  </Button>
                </Col>
              </Row>
            )}
          </Formik>
        </>
      ) : (
        <Button onClick={toggleOpen}>Alterar senha</Button>
      )}
    </>
  );
};

export default ResetPassword;
